import { LanguageResource } from '../type';

export const de: LanguageResource = {
  common: {
    hello: 'Hallo',
    hosts: 'Hosts',
    or: 'ODER',
    here: 'HERE',
    reason: 'Grund',
    licensedashboard: 'Lizenz Dashboard',
  },
  auth: {
    login: 'Einloggen',
    signup: 'Registrieren',
    terms5: 'Mit der Registrierung erklären Sie sich einverstanden mit unseren',
  },
  signin: {
    signin: 'Einloggen',
    rememberme: 'Angemeldet bleiben',
    forgotpassword: 'Passwort vergessen?',
    signup: 'Registrieren',
    logout: 'Abmelden',
    username: 'Benutzername',
    password: 'Passwort',
    'confirm-password': 'Passwort bestätigen',
    terms1: 'Mit der Anmeldung erklären Sie sich mit unseren',
    terms2: 'Nutzungsbedingungen',
    terms3: 'und',
    terms4: 'Datenschutzbestimmungen',
    sso: 'SSO Anmeldung',
    or: 'oder',
  },
  error: {
    servermalfunction: 'Fehler Serverstörung',
    contactyourserveradmin:
      'Wenden Sie sich an Ihren Server-Administrator oder überprüfen Sie Ihre Netzwerkeinstellungen',
    billingerroroccured: 'Fehler bei der Abrechnung/Zahlung aufgetreten',
    checkbillingsetting: 'Überprüfen Sie die Abrechnungseinstellungen Ihres Tenants in der',
  },
  info: {
    connectmultiplehosts: 'Mehrere Hosts verbinden',
    connectatleasttwohostsonanetworktobegincommunication:
      'Verbinden Sie mindestens zwei Hosts in einem Netzwerk, um die Kommunikation zu ermöglichen.',
  },
  hosts: {
    connectahost: 'Host verbinden',
  },
};
